import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";

// helper
import { OnboardingRoute } from "helper/route";

// layout
import OnestockOnboardingLayout from "containers/JarvisOnestock/OnestockOnboardingLayout";

// pages
import OnestockOnboardingOverview from "pages/JarvisOnestock/OnestockOnboardingOverview";
import OnestockRiskAssessment from "pages/JarvisOnestock/OnestockOnboarding/OnestockRiskAssessment";
import OnestockPayment from "pages/JarvisOnestock/OnestockOnboarding/OnestockPayment";
import OnestockCkyc from "pages/JarvisOnestock/OnestockOnboarding/OnestockCkyc";

const JarvisOneStockOnboardingNavigator = (props) => {
  const { match, history } = props;

  const stageRouteMap = {
    OVERVIEW: "/jarvis-onestock/onboarding/overview",
    RISK_ASSESSMENT: "/jarvis-onestock/onboarding/risk-assessment",
    PAYMENT: "/jarvis-onestock/onboarding/payment",
    CKYC: "/jarvis-onestock/onboarding/ckyc",
  };

  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );

  const toCheckIsFirstRender = useSelector((state) => state.master.firstRender);

  const isOnestockOnboardingCompleted = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted
  );

  const currentStage = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.currentStage
  );

  React.useEffect(() => {
    if (toCheckIsFirstRender) return;
    const route = stageRouteMap[currentStage];
    if (route && history.location.pathname !== route) {
      history.replace(route);
    }
  }, [currentStage, toCheckIsFirstRender]);

  return (
    // new code to redirect if any onboarding completed  /customer/dashboard
    // old code to redirect if any onboarding completed  /jarvis-onestock/dashboard
    <Switch>
      <OnestockOnboardingLayout {...props}>
        <Switch>
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isOnestockOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/overview`}
            component={OnestockOnboardingOverview}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isOnestockOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/risk-assessment`}
            component={OnestockRiskAssessment}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isOnestockOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/payment`}
            component={OnestockPayment}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isOnestockOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/ckyc`}
            component={OnestockCkyc}
          />
        </Switch>
      </OnestockOnboardingLayout>
    </Switch>
  );
};

export default JarvisOneStockOnboardingNavigator;
